var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "totalForm",
              attrs: {
                model: _vm.totalForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _vm.showProperty("row")
                ? _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.row_cfg")))]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("row"),
                      expression: "showProperty('row')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.total_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeTotalCfg("row")
                        },
                      },
                      model: {
                        value: _vm.totalForm.row.showGrandTotals,
                        callback: function ($$v) {
                          _vm.$set(_vm.totalForm.row, "showGrandTotals", $$v)
                        },
                        expression: "totalForm.row.showGrandTotals",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("row") &&
                        _vm.totalForm.row.showGrandTotals,
                      expression:
                        "showProperty('row') && totalForm.row.showGrandTotals",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("row")
                            },
                          },
                          model: {
                            value: _vm.totalForm.row.reverseLayout,
                            callback: function ($$v) {
                              _vm.$set(_vm.totalForm.row, "reverseLayout", $$v)
                            },
                            expression: "totalForm.row.reverseLayout",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_top"))),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_bottom"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_label") },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: _vm.$t("chart.total_label"),
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTotalCfg("row")
                          },
                        },
                        model: {
                          value: _vm.totalForm.row.label,
                          callback: function ($$v) {
                            _vm.$set(_vm.totalForm.row, "label", $$v)
                          },
                          expression: "totalForm.row.label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.aggregation") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-select",
                          attrs: {
                            placeholder: _vm.$t("chart.aggregation"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("row")
                            },
                          },
                          model: {
                            value: _vm.totalForm.row.calcTotals.aggregation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.row.calcTotals,
                                "aggregation",
                                $$v
                              )
                            },
                            expression: "totalForm.row.calcTotals.aggregation",
                          },
                        },
                        _vm._l(_vm.aggregations, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.chart.type === "table-pivot"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.total_sort") },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.changeTotalCfg("row")
                                },
                              },
                              model: {
                                value: _vm.totalForm.row.totalSort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.totalForm.row, "totalSort", $$v)
                                },
                                expression: "totalForm.row.totalSort",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "none" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_none"))),
                              ]),
                              _c("el-radio", { attrs: { label: "asc" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_asc"))),
                              ]),
                              _c("el-radio", { attrs: { label: "desc" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_desc"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.chart.type === "table-pivot" &&
                  _vm.totalForm.row.totalSort !== "none"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.total_sort_field") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-select",
                              attrs: {
                                placeholder: _vm.$t("chart.total_sort_field"),
                                size: "mini",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeTotalCfg("row")
                                },
                              },
                              model: {
                                value: _vm.totalForm.row.totalSortField,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.totalForm.row,
                                    "totalSortField",
                                    $$v
                                  )
                                },
                                expression: "totalForm.row.totalSortField",
                              },
                            },
                            _vm._l(_vm.totalSortFields, function (option) {
                              return _c("el-option", {
                                key: option.dataeaseName,
                                attrs: {
                                  label: option.name,
                                  value: option.dataeaseName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("row"),
                      expression: "showProperty('row')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.sub_total_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.rowNum < 2 },
                      on: {
                        change: function ($event) {
                          return _vm.changeTotalCfg("row")
                        },
                      },
                      model: {
                        value: _vm.totalForm.row.showSubTotals,
                        callback: function ($$v) {
                          _vm.$set(_vm.totalForm.row, "showSubTotals", $$v)
                        },
                        expression: "totalForm.row.showSubTotals",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("row") &&
                        _vm.totalForm.row.showSubTotals,
                      expression:
                        "showProperty('row') && totalForm.row.showSubTotals",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.rowNum < 2 },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("row")
                            },
                          },
                          model: {
                            value: _vm.totalForm.row.reverseSubLayout,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.row,
                                "reverseSubLayout",
                                $$v
                              )
                            },
                            expression: "totalForm.row.reverseSubLayout",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_top"))),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_bottom"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_label") },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: _vm.rowNum < 2,
                          placeholder: _vm.$t("chart.total_label"),
                          size: "mini",
                          clearable: "",
                        },
                        on: { change: _vm.changeTotalCfg },
                        model: {
                          value: _vm.totalForm.row.subLabel,
                          callback: function ($$v) {
                            _vm.$set(_vm.totalForm.row, "subLabel", $$v)
                          },
                          expression: "totalForm.row.subLabel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.aggregation") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-select",
                          attrs: {
                            disabled: _vm.rowNum < 2,
                            placeholder: _vm.$t("chart.aggregation"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("row")
                            },
                          },
                          model: {
                            value: _vm.totalForm.row.calcSubTotals.aggregation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.row.calcSubTotals,
                                "aggregation",
                                $$v
                              )
                            },
                            expression:
                              "totalForm.row.calcSubTotals.aggregation",
                          },
                        },
                        _vm._l(_vm.aggregations, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showProperty("col")
                ? _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.col_cfg")))]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("col"),
                      expression: "showProperty('col')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.total_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeTotalCfg("col")
                        },
                      },
                      model: {
                        value: _vm.totalForm.col.showGrandTotals,
                        callback: function ($$v) {
                          _vm.$set(_vm.totalForm.col, "showGrandTotals", $$v)
                        },
                        expression: "totalForm.col.showGrandTotals",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("col") &&
                        _vm.totalForm.col.showGrandTotals,
                      expression:
                        "showProperty('col') && totalForm.col.showGrandTotals",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("col")
                            },
                          },
                          model: {
                            value: _vm.totalForm.col.reverseLayout,
                            callback: function ($$v) {
                              _vm.$set(_vm.totalForm.col, "reverseLayout", $$v)
                            },
                            expression: "totalForm.col.reverseLayout",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_left"))),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_label") },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: _vm.$t("chart.total_label"),
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTotalCfg("col")
                          },
                        },
                        model: {
                          value: _vm.totalForm.col.label,
                          callback: function ($$v) {
                            _vm.$set(_vm.totalForm.col, "label", $$v)
                          },
                          expression: "totalForm.col.label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.aggregation") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-select",
                          attrs: {
                            placeholder: _vm.$t("chart.aggregation"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("col")
                            },
                          },
                          model: {
                            value: _vm.totalForm.col.calcTotals.aggregation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.col.calcTotals,
                                "aggregation",
                                $$v
                              )
                            },
                            expression: "totalForm.col.calcTotals.aggregation",
                          },
                        },
                        _vm._l(_vm.aggregations, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.chart.type === "table-pivot"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.total_sort") },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.changeTotalCfg("col")
                                },
                              },
                              model: {
                                value: _vm.totalForm.col.totalSort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.totalForm.col, "totalSort", $$v)
                                },
                                expression: "totalForm.col.totalSort",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "none" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_none"))),
                              ]),
                              _c("el-radio", { attrs: { label: "asc" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_asc"))),
                              ]),
                              _c("el-radio", { attrs: { label: "desc" } }, [
                                _vm._v(_vm._s(_vm.$t("chart.total_sort_desc"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            false &&
                            _vm.chart.type === "table-pivot" &&
                            _vm.totalForm.col.totalSort !== "none",
                          expression:
                            "false && chart.type === 'table-pivot' && totalForm.col.totalSort !== 'none'",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_sort_field") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-select",
                          attrs: {
                            placeholder: _vm.$t("chart.total_sort_field"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("col")
                            },
                          },
                          model: {
                            value: _vm.totalForm.col.totalSortField,
                            callback: function ($$v) {
                              _vm.$set(_vm.totalForm.col, "totalSortField", $$v)
                            },
                            expression: "totalForm.col.totalSortField",
                          },
                        },
                        _vm._l(_vm.totalSortFields, function (option) {
                          return _c("el-option", {
                            key: option.dataeaseName,
                            attrs: {
                              label: option.name,
                              value: option.dataeaseName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("col"),
                      expression: "showProperty('col')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.sub_total_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.colNum < 2 },
                      on: {
                        change: function ($event) {
                          return _vm.changeTotalCfg("col")
                        },
                      },
                      model: {
                        value: _vm.totalForm.col.showSubTotals,
                        callback: function ($$v) {
                          _vm.$set(_vm.totalForm.col, "showSubTotals", $$v)
                        },
                        expression: "totalForm.col.showSubTotals",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("col") &&
                        _vm.totalForm.col.showSubTotals,
                      expression:
                        "showProperty('col') && totalForm.col.showSubTotals",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.colNum < 2 },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("col")
                            },
                          },
                          model: {
                            value: _vm.totalForm.col.reverseSubLayout,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.col,
                                "reverseSubLayout",
                                $$v
                              )
                            },
                            expression: "totalForm.col.reverseSubLayout",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_left"))),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("chart.total_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.total_label") },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: _vm.colNum < 2,
                          placeholder: _vm.$t("chart.total_label"),
                          size: "mini",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeTotalCfg("col")
                          },
                        },
                        model: {
                          value: _vm.totalForm.col.subLabel,
                          callback: function ($$v) {
                            _vm.$set(_vm.totalForm.col, "subLabel", $$v)
                          },
                          expression: "totalForm.col.subLabel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.aggregation") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-select",
                          attrs: {
                            disabled: _vm.colNum < 2,
                            placeholder: _vm.$t("chart.aggregation"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTotalCfg("col")
                            },
                          },
                          model: {
                            value: _vm.totalForm.col.calcSubTotals.aggregation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.totalForm.col.calcSubTotals,
                                "aggregation",
                                $$v
                              )
                            },
                            expression:
                              "totalForm.col.calcSubTotals.aggregation",
                          },
                        },
                        _vm._l(_vm.aggregations, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }